import type { DeliveryStatus } from "./api";
import { msg } from "./i18n";

/** Track & Trace: Anzeige der Zustellstatus (gleich in Liste, Detail und Handlungsbedarf) */
export const DELIVERY_VIEW: Record<DeliveryStatus, { label: string; tone: "neutral" | "info" | "success" | "warning" | "danger" }> = {
  pre_transit: { label: msg("Angekündigt"), tone: "neutral" },
  in_transit: { label: msg("Unterwegs"), tone: "info" },
  out_for_delivery: { label: msg("In Zustellung"), tone: "info" },
  pickup_ready: { label: msg("Zur Abholung bereit"), tone: "warning" },
  delivered: { label: msg("Zugestellt"), tone: "success" },
  exception: { label: msg("Zustellproblem"), tone: "danger" },
  returned: { label: msg("Zurück an Absender"), tone: "danger" },
};
